<template>
  <b-modal
    v-model="show"
    hide-header
    centered
    hide-footer
    no-close-on-backdrop
    no-close-on-esc
  >
    <div class="discrepant-success-modal-body d-flex px-3 py-4">
      <div class="mr-4">
        <img
          height="auto"
          width="30"
          :src="require('@/assets/images/common/check.svg')"
        />
      </div>
      <div>
        <h3 class="title mb-3">
          {{ $t('invoices.add.helpers.discrepantInvoice.modal.title') }}
        </h3>
        <p class="mb-4">
          {{ $t('invoices.add.helpers.discrepantInvoice.modal.desc') }}
        </p>
        <b-button variant="primary" @click="$emit('close')">
          {{ $t('invoices.add.helpers.discrepantInvoice.modal.ok') }}
        </b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      required: false,
      default: false
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/scss/_variables.scss';
.discrepant-success-modal-body {
  font-family: $nunito;
  .title {
    font-weight: 700;
  }
}
</style>
